import styled from 'styled-components'
import { mediaQ, fontSizeResponsive } from '../../../theme/mixins'
import arrowLeft from '../../../../assets/DietModuleAssets/arrowLeft.png'
import arrowRight from '../../../../assets/DietModuleAssets/arrowRight.png'

import GreenArrowLeft from '../../../../assets/REDESIGN_Assets/Diet/arrow-left.svg'
import GreenArrowRight from '../../../../assets/REDESIGN_Assets/Diet/arrow-right.svg'

export const DailyBalanceContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    margin-top: 3vh;
  }
`

export const DaySwitcher = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const DaySwitcherDate = styled.div`
  font-family: 'Nunito';
  font-size: 1.2rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0 15px;
  text-align: center;
`

export const DaySwitcherButton = styled.button`
  background: ${(props) =>
    props.next ? `url(${GreenArrowRight})` : `url(${GreenArrowLeft})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 15px;
  height: 15px;
  border: none;
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 10px;

  background-color: #342152;
  margin-top: 30px;
  position: relative;
  border-radius: 2px;
  box-shadow: 0 0px 2.2px rgba(0, 0, 0, 0.02), 0 0px 5.3px rgba(0, 0, 0, 0.028),
    0 0px 10px rgba(0, 0, 0, 0.035), 0 0px 17.9px rgba(0, 0, 0, 0.042),
    0 0px 33.4px rgba(0, 0, 0, 0.05), 0 0px 80px rgba(0, 0, 0, 0.07);

  @media only screen and (max-width: 600px) {
    height: 5px;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: ${(props) => (props.progress ? props.progress + '%' : null)};
    height: 100%;
    background: #a1ff68;
    border-radius: 2px;
    max-width: 100%;
  }
`

export const NutritionalValuesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`

export const NutritionalValue = styled.div`
  display: flex;
  flex-direction: column;
`

export const Value = styled.span`
  width: 100%;
  display: inline-block;
  text-align: center;
  font-family: 'Open Sans';
  ${fontSizeResponsive(20)}
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  color: #212121;
`
export const Name = styled.span`
  width: 100%;
  display: inline-block;
  text-align: center;
  font-family: 'Open Sans';
  ${fontSizeResponsive(16)};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.78;
  letter-spacing: normal;
  color: #212121;
`
